module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="content-header">\r\n    <h1>\r\n        '+
((__t=(lang.GOODS_MANAGE))==null?'':_.escape(__t))+
'\r\n    </h1>\r\n</section>\r\n\r\n\r\n<section class="content">\r\n    <div class="row">\r\n        <div class="col-md-12 folderView">\r\n            ';

            var folders = [];            
            switch(parent){
                case 0:
                    folders = options;
                    
                    break;
                default:
                    // Is a subfolder                    
                    if(parent < 1000){
                        options.push({
                            id: -1,
                            item: "PARENT"
                        });
                        folders = options.reverse();
                    }else{
                        _.each(options, function(option){
                            if(option.id == parent)
                                folders = option.children;
                        });

                        //Add level up option
                        folders = _.extend([{
                            id: -1,
                            item: "PARENT",
                            parent: parent 
                        }], folders);
                    }
                break;
            }
           _.each(folders, function(option) {
               if(!option)
                return;

                var childText = lang[option.item];                
                if(option.parent < 1000 && !option.parent){
                    var childItemSlug = option.item.split('_')[0]
                    var childItem =  childItemSlug + "_" + option.id;
                } else {
                    var childItem =  option.item;
                }

                var folderVisible = "";
                if( (childItem == "ENVIRO") || (childItem == "USERS") || (childItem == "COMPANIES")) folderVisible = "hidden";
            
__p+='\r\n\r\n                <div class="col-md-2 col-sm-4 col-xs-6 centFold '+
((__t=(folderVisible))==null?'':_.escape(__t))+
'">\r\n                    <div class="info-box folder-select" data-id="'+
((__t=(option.id))==null?'':_.escape(__t))+
'" data-item="'+
((__t=(childItem))==null?'':_.escape(__t))+
'" data-parent="'+
((__t=(option.parent))==null?'':_.escape(__t))+
'">\r\n                        <span class="info-box-icon bg-yellow pointer folder">\r\n                        ';

                        if(option.id===-1)
                            print('<i class="ion ion-ios-arrow-thin-left"></i>');
                        else
                            print('<i class="ion ion-ios-folder-outline"></i>');                            
                        
__p+='\r\n                    </span>\r\n                    </div>\r\n                    <div class="folder-name">\r\n                        <a id="'+
((__t=(childItem))==null?'':_.escape(__t))+
'" data-name="menu'+
((__t=(option.id))==null?'':_.escape(__t))+
'" data-id="'+
((__t=(option.id))==null?'':_.escape(__t))+
'">\r\n                            '+
((__t=(childText))==null?'':_.escape(__t))+
'\r\n                        </a>\r\n                    </div>\r\n                </div>\r\n                ';
 });
__p+='\r\n        </div>\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/menu/menuView.ejs
// module id = 435
// module chunks = 0